module.exports = __webpack_public_path__ + "static/finam-c5615ce3c6351c5488b9bc974d6803cf.svg";